export const ARTICLE_STATUS_ACTIVE = 'active'
export const ARTICLE_STATUS_DRAFT = 'draft'
export const ARTICLE_STATUS_ARCHIVE = 'archive'
